import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
//spi
import { createAffiliation } from 'api/company';
//components
import Title from 'components/backoffice/texts/title';
import AffiliationForm from 'components/backoffice/forms/affiliationForm';

const CreateAffiliation = () => {
  const { t } = useTranslation(['backoffice']);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { setTitle } = useOutletContext();

  const affiliation = {
    name: '',
    address: '',
    phone: '',
    email: '',
    request_description: '',
    status: ''
  };

  useEffect(() => {
    setTitle(t('createAffiliation'));
    return () => {
      setTitle('');
    };
  }, [setTitle, t]);

  const onSubmit = useCallback(async (values) => {
    setLoading(true);
    const data = {
      name: values.name,
      address: values.address,
      phone: values.phone,
      email: values.email,
      request_description: values.request_description,
      status: values.status,
    };
    try {
      const { status } = await createAffiliation(data);
      if (status === 201) {
        toast.success(t('creadocorrectamente'));
        navigate('/intranet/affiliation-request', { replace: true });
      } else {
        toast.error(`${t('error')} ${status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      toast.error(t('mensajeerror'), { theme: 'colored' });
    }
    setLoading(false);
  }, [t, navigate]);

  return (
    <div className="affiliation-create mt-5">
      <Title text={t('createAffiliation')} />
      <AffiliationForm
        loading={loading}
        isEditing={false}
        onSubmitForm={onSubmit}
        defaultValues={affiliation}
        beforeTitle={t('createAffiliation')}
      />
    </div>
  );
};

export default CreateAffiliation;